import {
  addExternalGuest,
  addGuest,
  calculatePrice,
  cancelBooking,
  checkCancelFeasibility,
  checkGuestList,
  getBookingEvents,
  getBookingSlot,
  getCalendarParticipant,
  getGuestList,
  getPaymentStatus,
  getQuoteInfo,
  saveBookingSlot,
} from "./booking.service";
import { getContactPerson } from "./contactPerson.service";
import { getLocation } from "./organisation.service";
import { getUnitDetails } from "./unit.service";
import {
  accountDeletion,
  checkAccountDeletion,
  checkInvitationPageShow,
  createUserDetails,
  deleteMemberInfo,
  getMemberInfo,
  getOrganisationList,
  getPasswordTokenValid,
  getRegisterOptions,
  getRegistrationInvitation,
  getUserBookingDetails,
  getUserBookings,
  getUserProfile,
  getUserSelectedLanguage,
  invitedSetPassword,
  login,
  loginAccess,
  loginUser,
  logOut,
  mailVerification,
  notificationDisable,
  notificationEnable,
  notificationSubscribe,
  notificationUnsubscribe,
  resendMailVerification,
  resetPassword,
  setPassword,
  updateUserLanguage,
  updateUserProfile,
} from "./user.service";

const API_SERVICES = {
  BOOKING: {
    ADD_EXTERNAL_GUEST: addExternalGuest,
    ADD_GUEST: addGuest,
    CALCULATE_PRICE: calculatePrice,
    CANCEL_BOOKING: cancelBooking,
    CHECK_CANCEL_FEASIBILITY: checkCancelFeasibility,
    CHECK_GUEST_LIST: checkGuestList,
    GET_BOOKING_EVENTS: getBookingEvents,
    GET_BOOKING_EVENTS_PARTICIPANT: getCalendarParticipant,
    GET_BOOKING_SLOT: getBookingSlot,
    GET_GUEST_LIST: getGuestList,
    GET_QUOTE_INFO: getQuoteInfo,
    PAYMENT_STATUS: getPaymentStatus,
    SAVE_BOOKING: saveBookingSlot,
  },
  CONTACT_PERSON: { GET_CONTACT_PERSON: getContactPerson },
  DASHBOARD: {
    ORGANIZATION_FINDER: getOrganisationList,
  },
  LOGIN: login,
  LOGIN_ACCESS: loginAccess,
  LOGIN_USER: loginUser,
  MAIL_VERIFICATION: mailVerification,
  NOTIFICATION: {
    DISABLE: notificationDisable,
    ENABLE: notificationEnable,
    SUBSCRIBE: notificationSubscribe,
    UNSUBSCRIBE: notificationUnsubscribe,
  },
  ORGANISATION: {
    GET_LOCATION: getLocation,
  },
  RESEND_MAIL_VERIFICATION: resendMailVerification,
  RESET_PASSWORD: resetPassword,
  UNIT: {
    DETAILS: getUnitDetails,
  },
  USER: {
    ACCOUNT_DELETE: accountDeletion,
    CHECK_ACCOUNT_DELETE: checkAccountDeletion,
    CHECK_INVITATION_PAGE_SHOW: checkInvitationPageShow,
    DELETE_MEMBER_INFO: deleteMemberInfo,
    GET_MEMBER_INFO: getMemberInfo,
    GET_REGISTER_OPTIONS: getRegisterOptions,
    GET_USER_BOOKING_DETAILS: getUserBookingDetails,
    GET_USER_BOOKINGS: getUserBookings,
    GET_USER_DETAILS: createUserDetails,
    GET_USER_PROFILE: getUserProfile,
    INVITED_USER_SET_PASSWORD: invitedSetPassword,
    LOG_OUT: logOut,
    LOGIN: login,
    LOGIN_ACCESS: loginAccess,
    LOGIN_USER: loginUser,
    MAIL_VERIFICATION: mailVerification,
    PROFILE: getUserProfile,
    REGISTRATION_INVITATION: getRegistrationInvitation,
    RESEND_MAIL_VERIFICATION: resendMailVerification,
    RESET_PASSWORD: resetPassword,
    RESET_PASSWORD_TOKEN_VALIDITY: getPasswordTokenValid,
    SELECTED_LANGUAGE: getUserSelectedLanguage,
    SET_PASSWORD: setPassword,
    UPDATE_LANGUAGE: updateUserLanguage,
    UPDATE_USER_PROFILE: updateUserProfile,
  },
};

export default API_SERVICES;
